import { Component, OnInit } from '@angular/core';
import { DwMessage, DwMessageSeverity, DwRoutingService } from '@devwareapps/devware-cap';
import { AviatorLoginPageComponent } from '../aviator-login-page/aviator-login-page.component';
import { StripeSessionDetailsResult } from '../../../payments/models/stripe-session-details-result.model';

@Component({
  selector: 'app-aviator-registration-page',
  templateUrl: './aviator-registration-page.component.html',
  styleUrls: ['./aviator-registration-page.component.scss']
})
export class AviatorRegistrationPageComponent extends AviatorLoginPageComponent {
   
  

   setupStripeSession(stripeSessionDetails: StripeSessionDetailsResult) {
     super.setupStripeSession(stripeSessionDetails);

     if (stripeSessionDetails.IsExistingUser) {
        this.dwRoutingService.navigateToUrl('/login', null);
     }
   }
}
